import React, { useState, useEffect } from "react";
import SendBtn from "../../utils/Register/send_btn";
import conversion from "../../assets/wito.png";
import backImage from "../../assets/fondo.png";
import CircleAvatar from "../../utils/Register/circular_profile_img";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ProfileOrganizationImg = () => {
  const navigate = useNavigate();
  const [profileOrgImage, setProfileOrgImage] = useState(null);
  const [error, setError] = useState("");
  const [organizations, setOrganizations] = useState([]);
  const [selectedOrganization, setSelectedOrganization] = useState(null);
  const token = useSelector((state) => state.user.token);

  useEffect(() => {
    if (!token) {
      console.log("Token no disponible, esperando...");
      return;
    }

    const fetchOrganizations = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/organizations/`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          },
        );

        if (!response.ok) {
          throw new Error("Error al obtener las organizaciones.");
        }

        const data = await response.json();
        setOrganizations(data);

        if (data.length === 1) {
          setSelectedOrganization(data[0].id);
        }
      } catch (error) {
        setError("Error al cargar las organizaciones: " + error.message);
      }
    };

    fetchOrganizations();
  }, [token]);

  const handleSetLogo = async (e) => {
    e.preventDefault();

    if (!profileOrgImage || !selectedOrganization) {
      setError("Selecciona una imagen y una organización antes de continuar.");
      return;
    }

    const formData = new FormData();
    formData.append("org_image", profileOrgImage);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/organizations/${selectedOrganization}/logo`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        },
      );

      if (!response.ok) {
        throw new Error("Error al actualizar la foto de la organización.");
      }

      window.location.href = "/";
    } catch (error) {
      setError("Error al actualizar la foto: " + error.message);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div
        className="flex flex-col items-center bg-cover bg-center rounded-xl"
        style={{
          backgroundImage: `url(${backImage})`,
          maxWidth: "420px",
          padding: "0 5%",
          backgroundClip: "padding-box",
        }}
      >
        <div className="text-center text-white mb-8 mt-12">
          <h1 className="text-5xl font-bold">Ahora sí!</h1>
          <p className="text-lg mt-2">Terminamos</p>
          <div className="flex justify-center mt-2">
            <img src={conversion} alt="Conversión" className="h-8" />
          </div>
        </div>

        <div className="bg-white p-8 rounded-xl shadow-lg w-96">
          <h2 className="text-2xl font-bold text-center mb-6">
            Selecciona el logo de tu organización
          </h2>
          <form onSubmit={handleSetLogo}>
            {organizations.length > 1 && (
              <div className="mb-4">
                <label
                  htmlFor="organization"
                  className="block text-gray-700 font-bold mb-2"
                >
                  Selecciona una organización:
                </label>
                <select
                  id="organization"
                  value={selectedOrganization || ""}
                  onChange={(e) =>
                    setSelectedOrganization(parseInt(e.target.value))
                  }
                  className="w-full border rounded-lg p-2"
                >
                  <option value="" disabled>
                    -- Selecciona --
                  </option>
                  {organizations.map((org) => (
                    <option key={org.id} value={org.id}>
                      {org.name}
                    </option>
                  ))}
                </select>
              </div>
            )}
            <div className="flex items-center justify-center">
              <CircleAvatar
                size={150}
                onImageSelect={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    setProfileOrgImage(file);
                  }
                }}
              />
            </div>
            <SendBtn
              label="Subir"
              type="submit"
              style={{ backgroundColor: "#E5960E" }}
            />
            <button
              className="w-full py-2 mt-2 rounded-full hover:bg-gray-100"
              onClick={() => navigate("/")}
            >
              Omitir
            </button>
            {error && <p className="text-red-500">{error}</p>}
          </form>
        </div>
      </div>
    </div>
  );
};

export default ProfileOrganizationImg;
